import React, { useEffect } from 'react';
import Navbar from './Navbar';
import Footer from './Footer';

import { Helmet } from 'react-helmet-async';

const MarketingLayout = ({ children, title, description }) => {
    const siteTitle = "MedCoreX | Clinical Pharmacy Platform";
    const defaultDescription = "A clinician-designed clinical pharmacy platform for modern pharmacists. Reduce errors, save time, and improve patient outcomes with MedCoreX.";

    // Force English and LTR for marketing pages
    useEffect(() => {
        document.documentElement.dir = 'ltr';
        document.documentElement.lang = 'en';
    }, []);

    // Subtree uses class "dark" so marketing stays dark even if html theme is light (toggle hidden for now).
    return (
        <div className="dark min-h-screen bg-slate-950 text-slate-300 font-sans selection:bg-emerald-500/30 selection:text-emerald-200">
            <Helmet>
                <title>{title ? `${title} | MedCoreX` : siteTitle}</title>
                <meta name="description" content={description || defaultDescription} />
                <meta property="og:title" content={title ? `${title} | MedCoreX` : siteTitle} />
                <meta property="og:description" content={description || defaultDescription} />
                <meta property="og:type" content="website" />
                <meta name="twitter:card" content="summary_large_image" />
            </Helmet>
            <Navbar />
            <main className="pt-16 lg:pt-20">
                {children}
            </main>
            <Footer />
        </div>
    );
};

export default MarketingLayout;
